import React, { forwardRef, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";

const CommonInput = forwardRef((props, ref) => {

  const {
    type = "text",
    name,
    label,
    error,
    focus,
    labelClass,
    error_class = "",
    onChange,
    value,
    placeholder = '',
    className = "",
    min,
    max = 1000,
    onInput = () => { },
    maxLength = 1000,
    disabled = false,
   
    preAddon = false,
    postAddon = false,
    onKeyPress,
    onKeyDown,
    onClick,
    onFocus,
    labelRedStar=false,
    accept,
    isClearOption = false,
  isClearHandleChange,
  errorShow=true,
  borderStyle="false",
  whatsAbility,
  helpText,
  abilityTitle=""
  } = props;

  const invalid = !!(focus && error);
  const valid = !!Boolean(focus && !error);

  useEffect(() => {
    const inputFields = document.querySelectorAll("input");
    inputFields.forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });
  }, []);

  return (
    <div className={error ? "anvCustom_floatInput form-floating anvInputError" : "anvCustom_floatInput form-floating "}>
      <input
        autoComplete="off"
        disabled={disabled}
        ref={ref}
        name={name}
        type={type}
        onFocus={onFocus}
        id={name}
        className={"form-control" + className}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        min={min}
        max={max}
        onClick={onClick}
        maxLength={maxLength}
        onInput={onInput}
        onKeyDown={onKeyDown}
        accept={accept}
        onKeyPress={onKeyPress}
        
      />
      {isClearOption && value!= "All" && (
          <span className="clear-icon" onClick={isClearHandleChange}>
            <RxCross2 size={20} color="black" />
          </span>
        )}
      <label htmlFor="floatingInput">
        <span>{label} {labelRedStar && <span className="requiredLable"> * </span>}</span>
      </label>

      <div style={{display:"flex",flexDirection:"column"}}>
      {helpText && <small className="input-help-text">{helpText}</small>} 
     {errorShow &&  <>
      {error && (
        <span className={"input_drop_error" + error_class}>
          {error}
        </span>
      )}
      
      </>}
      {whatsAbility &&  <>
      {borderStyle == "yes" && (
        <span className={"input_drop_whatsYes" }>
          {abilityTitle} <FaCheckCircle />
        </span>
      )}
      
      </>}

      {whatsAbility &&  <>
        {borderStyle =="no" && (
        <span className={"input_drop_whatsNO" }>
            {abilityTitle} <MdCancel />
        </span>
     )}
     
      
     </>}
     
      </div>
     
    </div>
  );
});

export default CommonInput;